__turbopack_context__.v({
  "base": "Icon-module__SzVwOG__base",
  "icon-pulse": "Icon-module__SzVwOG__icon-pulse",
  "icon-spin": "Icon-module__SzVwOG__icon-spin",
  "pulse": "Icon-module__SzVwOG__pulse",
  "size2xl": "Icon-module__SzVwOG__size2xl",
  "size2xs": "Icon-module__SzVwOG__size2xs",
  "sizeLg": "Icon-module__SzVwOG__sizeLg",
  "sizeMd": "Icon-module__SzVwOG__sizeMd",
  "sizeSm": "Icon-module__SzVwOG__sizeSm",
  "sizeXl": "Icon-module__SzVwOG__sizeXl",
  "sizeXs": "Icon-module__SzVwOG__sizeXs",
  "spin": "Icon-module__SzVwOG__spin",
});
